// @ts-nocheck
document.addEventListener("alpine:init", () => {
  Alpine.store("cartDrawerStore", {
    products: Alpine.$persist([]),
    cartDrawerSectionId: "",
    sellingPlan: Alpine.$persist(null),

    /**
     * @param {string | number | null} sellingPlanId
     */
    setSellingPlan(sellingPlanId) {
      this.sellingPlan = Number(sellingPlanId) || null;
    },

    updateProducts(products) {
      this.products = products;
    },
  });
  /**
   * @param {{sellingPlans: Array<{id: number | null, name: string}>, sectionId: string}} component
   */
  Alpine.data("cartDrawer", function ({ sellingPlans = [], sectionId = "" }) {
    return {
      sellingPlans: [...sellingPlans],
      isSubscriptionActive: this.$persist(false),
      benefitsActive: true,
      sectionId,
      /** @type {Array<{id: number, quantity: number, sellingPlan: number | null}>} */
      cartProducts: Alpine.$persist([]),
      /** @type {Array<{id: number}>} */
      cartProductsWithoutAvailableSellingPlans: [],
      init() {
        this.$store.cartDrawerStore.cartDrawerSectionId = sectionId;
        this.$store.cartDrawerStore.updateProducts(this.parseCartProductsJSON());
        
        window.addEventListener('cart-drawer-store:update', (event) => {
          this.$store.cartDrawerStore.updateProducts(this.parseCartProductsJSON());
        });
      },

      /**
       * @returns {Array<{id: number, quantity: number, sellingPlan: number | null}>}
       */
      parseCartProductsJSON() {
        try {
          const cartProductsTemplate = this.$root.querySelector(
            ".cart-products-template"
          );
          if (!cartProductsTemplate) return [];
          return JSON.parse(cartProductsTemplate.textContent);
        } catch (error) {
          console.error("Error parsing cart products JSON:", error);
          return [];
        }
      },

      /**
       * @returns {Array<{id: number}>}
       */
      parseCartProductsIdsWithoutSellingPlansJSON() {
        try {
          const cartProductsTemplate = this.$root.querySelector(
            ".cart-products-without-selling-plans-template"
          );
          if (!cartProductsTemplate) return [];
          const ids = JSON.parse(cartProductsTemplate.textContent).map(
            /** @param {string} id */
            (id) => Number(id)
          );
          return ids;
        } catch (error) {
          console.error("Error parsing cart products JSON:", error);
          return [];
        }
      },

      onToggleSubscription() {
        if (!this.isSubscriptionActive) {
          this.$store.cartDrawerStore.setSellingPlan(null);
          this.updateCartItems();
        } else {
          this.$store.cartDrawerStore.setSellingPlan(this.sellingPlans[0]?.id);
          this.updateCartItems();
        }
      },

      /**
       * @param {Event} event
       */
      onChangeCartFrequency(event) {
        if (!(event.target instanceof HTMLSelectElement)) return;

        this.$store.cartDrawerStore.setSellingPlan(
          Number(event.target.value) || null
        );

        this.updateCartItems();
      },

      /**
       * @returns {string}
       */
      getBody() {
        const sectionsToUpdate = new Set([this.sectionId]);
        this.$store.cartDrawerStore.updateProducts(this.parseCartProductsJSON());

        const products = this.$store.cartDrawerStore.products;

        this.cartProductsWithoutAvailableSellingPlans =
          this.parseCartProductsIdsWithoutSellingPlansJSON();

          const itemsToUpdate = products.map(
          /** @param {{id: number, sellingPlan: number|undefined, quantity: number}} product */
          (product) => {
            if (
              this.cartProductsWithoutAvailableSellingPlans.includes(product.id)
            ) {
              return {
                id: product.id,
                quantity: product.quantity,
              };
            }

            return {
              id: product.id,
              quantity: product.quantity,
              selling_plan: this.$store.cartDrawerStore.sellingPlan,
            };
          }
        );

        const body = JSON.stringify({
          items: itemsToUpdate,
          sections: Array.from(sectionsToUpdate).join(","),
        });

        return body;
      },

      async updateCartItems() {
        this.disableCartItems();

        try {
          // @ts-ignore
          const clearResponse = await fetch(Theme.routes.cart_clear_url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });
          const clearResponseText = await clearResponse.text();

          // Second: Add items after clearing is complete
          const addResponse = await fetch(
            `${Theme.routes.cart_add_url}`,
            window.fetchConfig("json", {
              body: this.getBody(),
            })
          );
          const addText = await addResponse.text();
          const parsedResponseText = JSON.parse(addText);

          if (parsedResponseText.errors) {
            // Handle errors
            console.error("Error adding items:", parsedResponseText.errors);
            return;
          }
          // Process the successful response
          const newSectionHTML = new DOMParser().parseFromString(
            parsedResponseText.sections[this.sectionId],
            "text/html"
          );
          // todo: use alpine x-ref instead
          const newCartHiddenItemCount = newSectionHTML.querySelector(
            '[ref="cartItemCount"]'
          )?.textContent;
          const newCartItemCount = newCartHiddenItemCount
            ? parseInt(newCartHiddenItemCount, 10)
            : 0;

          window.dispatchEvent(
            // @ts-ignore
            new CartUpdateEvent({}, this.sectionId, {
              itemCount: newCartItemCount,
              source: "cart-items-component",
              sections: parsedResponseText.sections,
            })
          );

          // @ts-ignore
          morphSection(
            this.sectionId,
            parsedResponseText.sections[this.sectionId]
          );

          window.dispatchEvent(new CustomEvent('cart-drawer-store:update'));
        } catch (error) {
          console.error("Error clearing cart:", error);
        } finally {
          this.enableCartItems();
        }
      },
      /**
       * Disables the cart items.
       */
      disableCartItems() {
        const cartItemsComponents = document.querySelectorAll(
          "cart-items-component"
        );
        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement) {
            item.classList.add("cart-items-disabled");
          }
        });
      },

      /**
       * Enables the cart items.
       */
      enableCartItems() {
        const cartItemsComponents = document.querySelectorAll(
          "cart-items-component"
        );
        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement) {
            item.classList.remove("cart-items-disabled");
          }
        });
      },
      // @ts-ignore
      morphCart(sectionId, html, reject) {
        const fragment = new DOMParser().parseFromString(html, "text/html");
        const existingElement = document.getElementById(
          // @ts-ignore
          buildSectionSelector(sectionId)
        );
        const newElement = fragment.getElementById(
          // @ts-ignore
          buildSectionSelector(sectionId)
        );

        if (!existingElement) {
          throw new Error(`Section ${sectionId} not found`);
        }

        if (!newElement) {
          throw new Error(
            `Section ${sectionId} not found in the section rendering response`
          );
        }

        // @ts-ignore
        morph(existingElement, newElement, reject);
      },
    };
  });
});
